import { MaintainanceData } from "types/common";
import { checkIfMaintainanceOverDay } from "./checkIfMaintainanceOverDay";

export const getMaintainanceMessage = (maintainanceData: MaintainanceData) => {
  const { startTime, endTime } = maintainanceData;
  const [mtStartHr, mtStartMin] = startTime.split(":").map(Number);
  const [mtEndHr, mtEndMin] = endTime.split(":").map(Number);
  const mtIsOverDay = checkIfMaintainanceOverDay(
    mtStartHr,
    mtStartMin,
    mtEndHr,
    mtEndMin
  );
  const startDate = new Date();
  const endDate = new Date();
  startDate.setUTCHours(mtStartHr);
  startDate.setUTCMinutes(mtStartMin);
  if (mtIsOverDay) {
    endDate.setDate(endDate.getDate() + 1);
  }
  endDate.setUTCHours(mtEndHr);
  endDate.setUTCMinutes(mtEndMin);

  const timeFormat: any = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "UTC",
  };

  const start = startDate.toLocaleString("en-US", timeFormat);
  const end = endDate.toLocaleString("en-US", timeFormat);
  return `Dapp would be unavailable after ${start} UTC till ${end} UTC`;
};
